require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./package-unpublished-reasonml-community-bs-discord-js.json") })
        }
      }, "path---package-unpublished-reasonml-community-bs-discord-js");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---package-unpublished-reasonml-community-bs-discord-js!./.cache/json/package-unpublished-reasonml-community-bs-discord-js.json
// module id = 952
// module chunks = 231608221292675